import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { Container, Col, Row, Form } from "react-bootstrap";
import SIPCalculator from './SIPCalculator/SIPCalculator';
import MFSIPCalcStepUp from './MFSIPCalcStepUp/MFSIPCalcStepUp';
import GoalSettingCalc from './GoalSettingCalc/GoalSettingCalc';
import GoalTopUpSIP from './GoalTopUpSIP/GoalTopUpSIP';
import CompoundingCalc from './CompoundingCalc/CompoundingCalc';
import RetirementPlanCalc from './RetirementPlanCalc/RetirementPlanCalc';
import FutureValueCalc from './FutureValueCalc/FutureValueCalc';
// import HumanLifeValCalc from './HumanLifeValCalc/HumanLifeValCalc';
// import CostInflation from './CostInflation/CostInflation';
import EducationPlanner from './EducationPlanner/EducationPlanner';
import calcTreeCircleBlue from "../../images/calc_tree-circle-blue.png";
import calcTreeCircleBeforeBlue from "../../images/calc_tree-circle-before-blue.png";
import calcTreeCircleOrange from "../../images/calc_tree-circle-orange.png";
import calcTreeCircleBeforeOrange from "../../images/calc_tree-circle-before-orange.png";
import "./Calculator.css";
import { useParams } from "react-router-dom";

function Calculator() {
    const { tabName } = useParams();
    const [value, setValue] = useState([]);
    const [show, setShow] = useState(true);
    const [showPlan, setShowPlan] = useState(true);
    const [windowSize, setWindowSize] = useState(getWindowSize());
    const [pathname, setPathname] = useState('');
    let valueTree;
    const handleChange = (e) => {
        valueTree = e.currentTarget.getAttribute('data-id');
        setValue(valueTree);
    }
    useEffect(() => {
        const pathname = window.location.pathname.replace("-", " ");
        const lastSegment = pathname.slice(pathname.lastIndexOf('/') + 1);
        const CategoryIdUrlid = lastSegment;
        // alert(CategoryIdUrlid)
        setPathname(CategoryIdUrlid)
        if (tabName === "Financial-Calculations") {
            setValue('1')
        }
        if (tabName === "Goal-Calculations") {
            setValue('1A')
        }
        if (tabName === "Child-Education-Calculator") {
            setValue('1D');
            document.getElementById('calcBtnGoal').click()

        }
        if (tabName === "Retirement-Calculator") {
            setValue('1C');
            document.getElementById('calcBtnGoal').click()
        }
        if (tabName === "Future-Value-Calculator") {
            setValue('5')
        }
        if (tabName === "Goal-top-Up-Calculator") {
            setValue('1B')
        }
        if (tabName === "Goal-Calculator") {
            setValue('1A')
            document.getElementById('calcBtnGoal').click()
        }
        if (tabName === "Power-of-Compounding-Calculator ") {
            setValue('3')
        }
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }
        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    function getWindowSize() {
        const { innerWidth } = window;
        return { innerWidth };
    }

    return (
        <>
            <Container>
                <Row>
                    <Col>
                        <ul className="navigator-arrow">
                            <li><a href="/" aria-label="Home"><i class="fa fa-home" aria-hidden="true"></i></a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                            <li><i>Calculator</i> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                            {/* <li>Calculator</li><i class="fa fa-angle-right" aria-hidden="true"></i> */}
                            {/* <li>{(pathname.replace("-", " "))}</li> */}
                            <li className="calcBreadcrum">{(value === '1') ? 'Systematic Investment Plan Calculator' : (value === '3') ? 'Power Of Compounding Calculator' : (value === '5') ? 'Impact Of Inflation Calculator' : (value === '1A') ? 'Goal Calculator' : (value === '1B') ? 'Goal Based Top-Up SIP Calculator' : (value === '1C') ? 'Retirement Calculator' : (value === '1D') ? 'Child Education Calculator' : ''}</li>
                        </ul>
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row>
                    <Col>
                        <div className="calc-desktop-tabs">
                            <div className="plan-wise-tabs tabs-tree">
                                <div className="tab-head-container">
                                    <div className="img-container">
                                        <img src={calcTreeCircleBlue} alt="calcTreeCircleBlue" />
                                    </div>
                                    <div className="tree-head blue">
                                        <button className="calcBtn" onClick={() => setShow(!show)}>Financial Calculations</button>
                                    </div>
                                </div>
                                {((windowSize.innerWidth) < 580) && showPlan ? show ?
                                    <div>
                                        <ul className="nav nav-pills" id="pills-tab" role="tablist">
                                            <li className="nav-item">
                                                <div className={(value === "1") ? "nav-link active" : "nav-link"} data-id="1" onClick={handleChange}>
                                                    <div className="circle-small"><img src={calcTreeCircleBeforeBlue} alt="CalculatorBeforeBlue"/></div>
                                                    <div className="circle blue"></div>Systematic Investment Plan Calculator
                                                </div>
                                            </li>
                                            {/* <li className="nav-item">
                                                <div className={(value === "2") ? "nav-link active" : "nav-link"} data-id="2" onClick={handleChange}>
                                                    <div className="circle-small"><img src={calcTreeCircleBeforeBlue} /></div>
                                                    <div className="circle blue"></div>SIP Top Up Calculator
                                                </div>
                                            </li> */}
                                            <li className="nav-item">
                                                <div className={(value === "3") ? "nav-link active" : "nav-link"} data-id="3" onClick={handleChange}>
                                                    <div className="circle-small"><img src={calcTreeCircleBeforeBlue} alt="CalculatorBeforeBlue"/></div>
                                                    <div className="circle blue"></div>Power of Compounding Calculator
                                                </div>
                                            </li>
                                            {/* <li className="nav-item">
                                                <div className={(value === "4") ? "nav-link active" : "nav-link"} data-id="4" onClick={handleChange}>
                                                    <div className="circle-small"><img src={calcTreeCircleBeforeBlue} /></div>
                                                    <div className="circle blue"></div>Human Life Value
                                                </div>
                                            </li> */}
                                            <li className="nav-item">
                                                <div className={(value === "5") ? "nav-link active" : "nav-link"} data-id="5" onClick={handleChange}>
                                                    <div className="circle-small"><img src={calcTreeCircleBeforeBlue} alt="CalculatorBeforeBlue"/></div>
                                                    <div className="circle blue"></div>Impact of Inflation Calculator
                                                </div>
                                            </li>
                                            {/* <li className="nav-item">
                                                <div className={(value === "6") ? "nav-link active" : "nav-link"} data-id="6" onClick={handleChange}>
                                                    <div className="circle-small"><img src={calcTreeCircleBeforeBlue} /></div>
                                                    <div className="circle blue"></div>Cost of Inflation
                                                </div>
                                            </li> */}
                                        </ul>
                                    </div> : '' : <div>
                                    <ul className="nav nav-pills" id="pills-tab" role="tablist">
                                        <li className="nav-item">
                                            <div className={(value === "1") ? "nav-link active" : "nav-link"} data-id="1" onClick={handleChange}>
                                                <div className="circle-small"><img src={calcTreeCircleBeforeBlue} alt="CalculatorBeforeBlue"/></div>
                                                <div className="circle blue"></div>Systematic Investment Plan Calculator
                                            </div>
                                        </li>
                                        {/* <li className="nav-item">
                                            <div className={(value === "2") ? "nav-link active" : "nav-link"} data-id="2" onClick={handleChange}>
                                                <div className="circle-small"><img src={calcTreeCircleBeforeBlue} /></div>
                                                <div className="circle blue"></div>SIP Top Up Calculator
                                                   </div>
                                        </li> */}
                                        <li className="nav-item">
                                            <div className={(value === "3") ? "nav-link active" : "nav-link"} data-id="3" onClick={handleChange}>
                                                <div className="circle-small"><img src={calcTreeCircleBeforeBlue} alt="CalculatorBeforeBlue"/></div>
                                                <div className="circle blue"></div>Power of Compounding Calculator
                                            </div>
                                        </li>
                                        {/* <li className="nav-item">
                                            <div className={(value === "4") ? "nav-link active" : "nav-link"} data-id="4" onClick={handleChange}>
                                                <div className="circle-small"><img src={calcTreeCircleBeforeBlue} /></div>
                                                <div className="circle blue"></div>Human Life Value
                                            </div>
                                        </li> */}
                                        <li className="nav-item">
                                            <div className={(value === "5") ? "nav-link active" : "nav-link"} data-id="5" onClick={handleChange}>
                                                <div className="circle-small"><img src={calcTreeCircleBeforeBlue} alt="CalculatorBeforeBlue"/></div>
                                                <div className="circle blue"></div>Impact of Inflation Calculator
                                            </div>
                                        </li>
                                        {/* <li className="nav-item">
                                            <div className={(value === "6") ? "nav-link active" : "nav-link"} data-id="6" onClick={handleChange}>
                                                <div className="circle-small"><img src={calcTreeCircleBeforeBlue} /></div>
                                                <div className="circle blue"></div>Cost of Inflation
                                            </div>
                                        </li> */}
                                    </ul>
                                </div>}
                            </div>
                            <div className="life-goal-tabs tabs-tree" id="life_goals_tab">
                                <div className="tab-head-container">
                                    <div className="img-container">
                                        <img src={calcTreeCircleOrange} alt="calcTreeCircleOrange" />
                                    </div>
                                    <div className="tree-head">
                                        <button className="calcBtn" id="calcBtnGoal" onClick={() => setShow(!show)}>Goal Calculations</button>
                                    </div>
                                </div>
                                {((windowSize.innerWidth) < 580) && show ? '' : <div>
                                    <ul className="nav nav-pills" role="tablist">
                                        <li className="nav-item">
                                            <div className={(value === "1A") ? "nav-link active" : "nav-link"} data-id="1A" onClick={handleChange}>
                                                <div className="circle-small"><img src={calcTreeCircleBeforeOrange} alt="CalculatorBeforeOrange"/></div>
                                                <div className="circle orange"></div>Goal Calculator
                                            </div>
                                        </li>
                                        <li className="nav-item">
                                            <div className={(value === "1B") ? "nav-link active" : "nav-link"} data-id="1B" onClick={handleChange}>
                                                <div className="circle-small"><img src={calcTreeCircleBeforeOrange} alt="CalculatorBeforeOrange"/></div>
                                                <div className="circle orange"></div>Goal Based Top-Up SIP calculator
                                            </div>
                                        </li>
                                        <li className="nav-item">
                                            <div className={(value === "1C") ? "nav-link active" : "nav-link"} data-id="1C" onClick={handleChange}>
                                                <div className="circle-small"><img src={calcTreeCircleBeforeOrange} alt="CalculatorBeforeOrange"/></div>
                                                <div className="circle orange"></div>Retirement Calculator
                                            </div>
                                        </li>
                                        <li className="nav-item">
                                            <div className={(value === "1D") ? "nav-link active" : "nav-link"} data-id="1D" onClick={handleChange}>
                                                <div className="circle-small"><img src={calcTreeCircleBeforeOrange} alt="CalculatorBeforeOrange" /></div>
                                                <div className="circle orange"></div>Child Education Calculator
                                            </div>
                                        </li>
                                    </ul>
                                </div>}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            {(value === "1") ? <SIPCalculator /> : (value === "2") ? <MFSIPCalcStepUp /> : (value === "3") ? <CompoundingCalc /> : (value === "5") ? <FutureValueCalc /> : (value === "1A") ? <GoalSettingCalc /> : (value === "1B") ? <GoalTopUpSIP /> : (value === "1C") ? <RetirementPlanCalc /> : (value === "1D") ? <EducationPlanner /> : ''}
        </>
    );
}

export default Calculator;